// eslint-disable-next-line 
export const componentsEnum = Object.freeze({
  selectArea: 1,
  beeSelectionMethod: 2,
  beeSelection: 3,
  plantSelectionMethod: 4,
  plantSelection: 5,
  floweringArch: 6,
  plantAdvice: 7,
  overview: 8,
  properties: {
    1: { route: '/select-area', step: 1 },
    2: { route: '/bee-selection-method', step: 2 },
    3: { route: '/bee-selection', step: 3 },
    4: { route: '/plant-selection-method', step: 4 },
    5: { route: '/plant-selection', step: 5 },
    6: { route: '/flowering-arch', step: 6 },
    7: { route: '/plant-advice', step: 7 },
    8: { route: '/overview', step: 8 },
  },
});
